// extracted by mini-css-extract-plugin
export default {"title":"WeedingPassTable_title__FcNCx","total":"WeedingPassTable_total__Epni1","pay":"WeedingPassTable_pay__L1KPe","edit":"WeedingPassTable_edit__6QUjy"};